var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0663 3.69922H6.92997C6.70179 3.69922 6.51634 3.88467 6.51634 4.11286V5.02195C6.51634 5.25013 6.70179 5.43558 6.92997 5.43558H9.10571L7.06186 12.5629H4.98395C4.75576 12.5629 4.57031 12.7483 4.57031 12.9765V13.8856C4.57031 14.1138 4.75576 14.2992 4.98395 14.2992H11.1203C11.3485 14.2992 11.5339 14.1138 11.5339 13.8856V12.9765C11.5339 12.7483 11.3485 12.5629 11.1203 12.5629H8.86787L10.9117 5.43558H13.0663C13.2945 5.43558 13.48 5.25013 13.48 5.02195V4.11286C13.48 3.88467 13.2945 3.69922 13.0663 3.69922Z",
    fill: "#100D40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.03d9a03e8dbaf7177d16872a9c6bcc13.svg";
export { ForwardRef as ReactComponent };